/* Style Dots menu bar: open desktop dropdowns and mega menus on hover.
   Click and keyboard still work as before. Touch screens keep tap-to-open. */
(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const menus = document.querySelectorAll('.sd-header .header__inline-menu details');
  menus.forEach((details) => {
    let closeTimer;
    details.addEventListener('mouseenter', () => {
      if (!canHover.matches) return;
      clearTimeout(closeTimer);
      menus.forEach((other) => {
        if (other !== details && other.hasAttribute('open')) {
          other.removeAttribute('open');
          other.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }
      });
      details.setAttribute('open', '');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    });
    details.addEventListener('mouseleave', () => {
      if (!canHover.matches) return;
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }, 180);
    });
  });
})();
